type TokenGetter = () => Promise<string | null>;
let _getter: TokenGetter | null = null;

export const registerClerkTokenGetter = (g: TokenGetter) => {
  _getter = g;
};

export const getClerkToken = (): Promise<string | null> =>
  _getter ? _getter() : Promise.resolve(null);
